import React from 'react';
import { Card, CardProps, Container, ContainerProps, Stack, StackProps } from '@mui/material';

interface CardPropsExtended extends CardProps {}

interface StackPropsExtended extends StackProps {}

interface CardTypes extends ContainerProps {
    children: React.ReactNode;
    cardProps?: CardPropsExtended;
    stackProps?: StackPropsExtended;
}

const CardWrapper = ({ children, cardProps, stackProps, ...props }: CardTypes) => {
    return (
        <Container sx={{ my: 1 }} {...props}>
            <Card sx={{ p: 4 }} {...cardProps}>
                <Stack {...stackProps}>{children}</Stack>
            </Card>
        </Container>
    );
};

export default CardWrapper;
